import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CookiesProvider } from 'react-cookie';
//?import TagManager from 'react-gtm-module';

//#region Google Analytics Dev Testing
/*
 const tagManagerArgs = {
                          gtmId: process.env.REACT_APP_GTM_ID as string,
                          events: {
                            pageView: 'Sage Central Index Page Loaded'
                          }
                        };
TagManager.initialize(tagManagerArgs);
*/
//#endregion

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <CookiesProvider>
    <App />
  </CookiesProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
